export enum MediaPublipostage {
  Courrier = 'Courrier',
  CourrierASigner = 'Courrier à signer',
  Email = 'Email',
}
